import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-muted text-foreground',
        outline: 'border-border text-foreground',
        success:
          'border-transparent bg-success-100 text-success-800 dark:bg-success-900/30 dark:text-success-200',
        warning:
          'border-transparent bg-warning-100 text-warning-800 dark:bg-warning-900/30 dark:text-warning-200',
        error:
          'border-transparent bg-error-100 text-error-800 dark:bg-error-900/30 dark:text-error-200',
        info: 'border-transparent bg-info-100 text-info-800 dark:bg-info-900/30 dark:text-info-200',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant, className }))} {...props} />
  ),
);
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
